import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

interface UIState {
  isTourOpen: boolean;
  isMenuOverlayOpen: boolean;
}

const initialState: UIState = {
  isTourOpen: false,
  isMenuOverlayOpen: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openTour: (state) => {
      state.isTourOpen = true;
    },
    closeTour: (state) => {
      state.isTourOpen = false;
    },
    // D45b Phase 3 — shared Menu overlay (glass bottom sheet on mobile,
    // glass popover on desktop). Opened from the mobile tab bar's Menu
    // item, the desktop rail's `⋯`, and the redirecting `/menu` route.
    openMenuOverlay: (state) => {
      state.isMenuOverlayOpen = true;
    },
    closeMenuOverlay: (state) => {
      state.isMenuOverlayOpen = false;
    },
  },
});

export const { openTour, closeTour, openMenuOverlay, closeMenuOverlay } = uiSlice.actions;

export const selectIsTourOpen = (state: RootState) => state.ui.isTourOpen;
export const selectIsMenuOverlayOpen = (state: RootState) => state.ui.isMenuOverlayOpen;

export default uiSlice.reducer;
